import React, { useState } from "react"
import ReactPlayer from "react-player"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import VideoSlider from "../components/sliders/video-slider"
import VideoSliderSecond from "../components/sliders/video-slider-duplicate"
import BlogSlider from "../components/sliders/video-slider-three-col"
import {
  ArrowDownIcon,
  ArrowLongRightIcon,
  ClockIcon,
} from "@heroicons/react/24/solid"
import Uploader from "../components/drop-zone/uploader"
import { useForm } from "react-hook-form"
import firebase from "firebase/compat/app"
import db from "../firebaseConfig"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"

const Blog = ({ data }) => {
  const images = {
    bggardening: convertToBgImage(getImage(data.gardening)),
    bggrow: convertToBgImage(getImage(data.grow)),
    bgvegetable: convertToBgImage(getImage(data.vegetable)),
    bgblog1: convertToBgImage(getImage(data.blog1)),
    bgblog2: convertToBgImage(getImage(data.blog2)),
    bgblog3: convertToBgImage(getImage(data.blog3)),
    bgblog4: convertToBgImage(getImage(data.blog4)),
    bgblog5: convertToBgImage(getImage(data.blog5)),
    bgblog6: convertToBgImage(getImage(data.blog6)),
    bgblog7: convertToBgImage(getImage(data.blog7)),
    bgblog8: convertToBgImage(getImage(data.blog8)),
    bgblog9: convertToBgImage(getImage(data.blog9)),
    bgblog10: convertToBgImage(getImage(data.blog10)),

    gardening: getImage(data.gardening),
    grow: getImage(data.grow),
    vegetable: getImage(data.vegetable),

    PopularBlog1: getImage(data.PopularBlog1),
    PopularBlog2: getImage(data.PopularBlog2),
    PopularBlog3: getImage(data.PopularBlog3),
    PopularBlog4: getImage(data.PopularBlog4),
    PopularBlog5: getImage(data.PopularBlog5),
    PopularBlog6: getImage(data.PopularBlog6),
    PopularBlog7: getImage(data.PopularBlog7),
    PopularBlog8: getImage(data.PopularBlog8),
    PopularBlog9: getImage(data.PopularBlog9),
    PopularBlog10: getImage(data.PopularBlog10),
  }
  const blog = [
    {
      topic: "ඉවතලන ප්ලාස්ටික් සඳහා ස්මාර්ට් විසඳුමක් ",
      date: "November 11,2022",
      desc: "එදිනෙදා ජීවිතයේ ප්ලාස්ටික් භාවිතය හැකිතාක් අවම කරගැනීමට අප කටයුතු කළ අතරම භාවිතයෙන් ඉවත් කරන ප්ලාස්ටික් ස්මාර්ට් අයුරින් වෙනත් කටයුතු සඳහා යොදා ගැනීමටත් උනන්දු වීම වැදගත්. නිවසේ ඉවත දමන අයිස්ක්‍රීම්, යෝගට්  ප්ලාස්ටික් බඳුන් තිබේ නම් ඒවා පරිසරයට එකතු නොකර ඔබේ ගෙවතු වගා කටයුතු සඳහා යොදා ගැනීම ඉතා හොඳ පුරුද්දක්. පළමුවෙන්ම හොඳින් පිරිසිදු කරගත් මෙම බඳුන්වල අඩියේ තරමක ලොකු සිදුරක් කපා වැඩි ජලය පිටතට එන සේ සකස් කළ යුතු වෙනවා. හිරු එළිය වැටෙන ආකාරය අනුව ස්ථානය වෙනස් කිරීමට හැකි වීමත්, ජලය යෙදීමේ පහසුවත් නිසා මෙවැනි බඳුන්වල වගා කිරීම ඔබේ කටයුතුවල අමතර පහසුවක් සලසනවා. ",
      image: images.bgblog7,
      image2: images.PopularBlog1,
      id: "blog1",
      shorturl: "#blog1",
    },
    {
      topic: "ගෙවත්තෙන්ම කොම්පෝස්ට් හදාගමු",
      date: "September 13,2022",
      desc: "ගෙදරදොරේ ඉවතලන ආහාර කොටස්, අපද්‍රව්‍ය හා ඉඳුල් වැනි දෑ බැහැර කළ හැකි සුදුසු ක්‍රමයක් නොමැති වීම අප බොහෝ දෙනා මුහුණ දෙන ගැටලුවක්. නමුත් මේ ගැටලුවට මනා විස﻿ඳුමක් ලබා දෙන අතරම ඔබේ ගෙවතු වගාවට අවශ්‍ය කොම්පෝස්ට් පොහොර නිවසේදීම සාදා ගැනීමටත් හැකි ඵලදායී ක්‍රමවේදයක් මේ තුළින් ඔබටම අත්හදා බැලීමට පුළුවන්.මෙය පොළොව මට්ටමේ සිට අඩි කිහිපයක් යටට හාරන වලක් ලෙස හෝ ලී දඬු යොදා වට කොට සාදා ගන්නා කොටුවක ආකාරයෙන් වුවත් කොම්පෝස්ට් ඒකකය සකසා ගන්න පුළුවන්. එසේත් නැතිනම් වෙළඳපොළෙන් ලබා ගත හැකි කොන්ක්‍රීට් බැරල් එකක් වුවත් භාවිතා කළ හැකියි.නිවසේ පරිභෝජනයෙන් ඉවතලන එළවළු, පළතුරු හා ඉඳුල් වැනි දෑ කොම්පෝස්ට් වල තුළ ඇතුරුමක් සේ යොදන්න. ඒ අතරට කොළරොඩු තට්ටු යෙදීමෙන් කාබන් ප්‍රතිශතය ඉහළ නංවා ගන්න පුළුවන්. හැකි නම් රිටක් භාවිතා කර වරින් වර මෙය කලවම් කිරීම, ඇතුළත ක්ෂුද්‍රජීවී ක්‍රියාවලිය ඉහළ නැංවීමට හේතු වෙනවා.මේ ආකාරයට සකසා ගන්නා කොම්පෝස්ට් පොහොර ඔබේ ගෙවතු වගාව සරු කිරීමට යොදාගත හැකි හොඳම කාබනික පොහොරක්.",
      image: images.bgblog1,
      image2: images.PopularBlog2,
      id: "blog2",
      shorturl: "#blog2",
    },
    {
      topic: "ගොළුබෙලි හානියෙන් මිදෙන්න",
      date: "September 12,2022",
      desc: "ගෙවතු වගාවක් ආරම්භ කිරීමෙන් පසු ඊට හානි කරන කෘමි සතුන් මෙන්ම ගොළුබෙල්ලන් වැනි සතුන් ද බොහෝ ප්‍රමාණයක් ගෙවත්ත ආශ්‍රිතව බෝ වීම සුලබ දෙයක්. එය සොබාදහමේ පැවැත්මට අදාළ නිත්‍ය කොටසක් නිසා ඔබ ඊට අනවශ්‍ය ලෙස කලබල විය යුතු නැහැ. නමුත් මෙම සතුන්ගෙන් භෝගවලට සිදුවන හානිය අවම කරගැනීමට විවිධ උපක්‍රම භාවිත කිරීමට ඔබට පුළුවන්.එසේ නමුත් මෙම සතුන් මුළුමනින්ම වඳ කර දැමීම සඳහා විවිධ රසායනික ද්‍රව්‍ය භාවිතය ඔබේ භෝගවලට වගේම ඔබටත් අහිතකරයි. ඒ නිසා අනවශ්‍ය හිංසක ක්‍රියාවන්වල නොයෙදී ඔබේ භෝග ආරක්ෂා කර ගැනීමට සුදුසු උපක්‍රම තෝරා ගැනීම ඔබේ වගාවට මෙන්ම ඔබේ ගුණාත්මක සිතුවිලිවලටත් සැනසිල්ලක් ලබා දෙනවා.ගොළුබෙල්ලන් වැනි සතුන් නොමරා ක්ෂේත්‍රෙයන් ඉවත් කිරීම ඔබට සරලවම කළ හැකි දෙයක්. එම සතුන් බෝ විය හැකි ස්ථාන සොයා බලා ඒවා පිරිසිදුව තැබීමෙන් බෝවීම බොහෝ දුරට පාලනය කර ගැනීමට පුළුවන්. ඒ වගේම සතුන්ට භෝගවලට ළඟා විය නොහැකි ආවරණ යෙදීම මඟිනුත් හානිය අවම කරගැනීමට හැකියි.",
      image: images.bgblog2,
      image2: images.PopularBlog3,
      id: "blog3",
      shorturl: "#blog3",
    },
    {
      topic: "වගා හානි කරන කෘමි සතුන් මෙල්ල කරමු ",
      date: "September 11,2022",
      desc: "භෝග වගාවක් ආරම්භ කළ සැණින් ක්ෂේත්‍රය ආශ්‍රිතව කෘමි ගහණය ඉහළ යාමක් ඔබට නිරීක්ෂණය කළ හැකියි. නමුත් මේ සතුන් මුළුමනින්ම වඳ කර දැමීම සඳහා කෘෂි රසායනික ද්‍රව්‍ය යෙදීම නම් කිසිසේත්ම නොකළ යුතුයි. කෘමි සතුන් කියන්නෙත් පරිසරයේ සමතුලිතතාව ආරක්ෂා කිරීම සඳහා සොබාදහම විසින්ම ලබා දුන් දෙයක් ලෙස සැලකීම යහපත් ගොවියෙකු විසින් අවබෝධ කරගත යුතු දෙයක්.නමුත් භෝගවලට දැඩිව හානි වීම වළක්වා ගැනීමට විවිධ උපාය උපක්‍රම ඔබට අත්හදා බැලීමට පුළුවන්. මේ සඳහා නිතරම කාබනික ක්‍රම භාවිතා කිරීම වැදගත් බවත් සිහියේ තබා ගන්න. මේ නිසා කෘමි සතුන් පාලනයට ඔබ ගන්නා පියවර 100%ක් පරිසර හිතකාමී වීම අවශ්‍යයි.ක්ෂේත්‍රය නිරන්තරයෙන් (සතියකට දෙවරක් වත්) පරික්ෂාවට ලක් කිරීම තුළින් ඔබට කෘමි හානිය කල් තියා හඳුනා ගෙන හානි වූ භෝග ඉවත් කිරීමෙන් අවදානම සෑහෙන දුරකට අවම කරගන්න පුළුවන්. කන්නෙන් කන්නයට භෝග මාරුව හෝ භූමි මාරුව සිදු කිරීම මඟිනුත් කෘමි පාලනයට අවම කරගත හැකියි. ඒ වගේම ක්ෂේත්‍රය පිරිසිදුව තබා ගැනීමත්, නිසි කාලයේ අස්වනු නෙළීමත් කෘමි හානිය අවම කරගැනීමට ඔබට අනුගමනය කළ හැකි සරල පිළිවෙත් කිහිපයක්. මීට අමතරව අපේ පැරැන්නන් විසින් අත්දුටු සරල කෘමි පාලන ක්‍රම වැනි දෑ වුවත් ඔබට අත්හදා බැලිය හැකියි. ",
      image: images.bgblog3,
      image2: images.PopularBlog4,
      id: "blog4",
      shorturl: "#blog4",
    },
    {
      topic: "ගෙවත්තකට නැතුව බැරි ඔසු පැළ",
      date: "September 11,2022",
      desc: "ගෙවතු වගාවේ නිරත වීම ඔබට කායික මෙන්ම මානසික සුව සහනය සැලසීමටත් උපකාරී වෙනවා. ඔබේ ගෙවත්තේ එළවළු හා පළතුරු භෝග පමණක් නොව එදිනෙදා අවශ්‍යවන ඖෂධ වර්ග ද වගා කිරීමෙන් පරිපූර්ණ ගෙවත්තකට හිමිකම් කීමට ඔබට අවකාශ ලැබෙනවා. කෝමාරිකා, කහ, කටුවැල් බටු, නෙල්ලි, කොහොඹ, ගොටුකොළ, හාතවාරිය, පොල්පලා, කරපිංචා වැනි ශාක හෙළ වෙදකමේ බහුලව භාවිතා වන ඖෂධ ලෙස සැලකෙනවා. ඔබ ජීවත් වන ප්‍රදේශයේ කාලගුණික, දේශගුණික සාධකවලට ගැළපෙන ඖෂධ වර්ග තෝරාගැනීමට මෙහිදී ඔබ සැලකිලිමත් විය යුතුයි.කැඳ සඳහා සුදුසු හාතවාරිය, ඉරමුසු, පොල්පලා, රණවරා, ගොටුකොළ, කරපිංචා වැනි භෝග වගා කිරීමෙන් උදෑසන ආහාරයට ප්‍රණීතවත් පිරිසිදු කැඳ වීදුරුවක් ද එකතු කර ගැනීමට මේ නිසා ඉඩකඩ ලැබෙනවා. එය ගෙවතු වගාවෙන් ඔබ බලාපොරොත්තු වන නිරෝගිමත් ජීවන රටාවට ඉතාමත් හොඳ පිටුබලයක් ද වනු නොඅනුමානයි. ",
      image: images.bgblog4,
      image2: images.PopularBlog5,
      id: "blog5",
      shorturl: "#blog5",
    },
    {
      topic: "දේශගුණය ගැන හරියට දැනගෙන වගා කරන්න",
      date: "September 11,2022",
      desc: "තමන් ජීවත්වන ප්‍රදේශයේ කාලගුණික, දේශගුණික රටාවන් පිළිබඳ හොඳ අවධානයක් තිබීම ගොවියෙකුට අත්‍යවශ්‍ය දැනුමක්. මේ නිසා ඔබේ කලාපයට වැසි ලැබෙන වකවානු, හිරු එළිය හොඳින් ලැබෙන වකවානු වගේම සුළං තත්ත්වයන් ඇතිවන කාල සමයන් ගැනත් විමසිලිමත් වීම සාර්ථක ගෙවතු වගාවකට මඟ පාදනවා.මේ සඳහා මුලින්ම ඔබ විසින් කළ යුතු දෙය වන්නේ ඔබේ ප්‍රදේශයට වැසි ලැබෙන කාල වකවානු නිවැරදිව දැන ගැනීමයි. ගොවි ව්‍යවහාරයේ යල, මහ ලෙස කන්න දෙකක් පිළිබඳ සඳහන් වුවත් ප්‍රදේශයෙන් ප්‍රදේශයට වැසි ලැබෙන ප්‍රමාණ හා කාලයන් වෙනස් වීමට ඉඩ තිබෙනවා. නිරිතදිග මෝසම් වැසි ලැබෙන අප්‍රේල්-සැප්තැම්බර් යල කන්නය ලෙසත්, ඊසානදිග මෝසම් වැසි ලැබෙන ඔක්තෝබර්-මාර්තු මහ කන්නය ලෙසත් හඳුන්වනු ලබනවා.අධික සුළං සහිත කාලයක බෝංචි, මෑ වැනි භෝග වගා කිරීම තරමක් අසාර්ථකයි. එවැනි සමයක ඔබ වගා කළ යුත්තේ සුළඟින් හානි නොවන භෝග වර්ග පමණයි. ඒ වගේම ක්ෂේත්‍රයට ජලය සැපයීමේ ක්‍රමය පිළිබඳවත් මනා අවබෝධයකින් යුතුව වගා කටයුතු ආරම්භ කිරීම ඔබේ කටයුතු වඩාත් පහසු කරනවා. වැඩියෙන් ජලය සැපයිය යුතු භෝග ඔබ ජලය ලබා ගන්නා ළිඳ හෝ ටැංකියට ආසන්නයෙන් වගා කිරීම නිසා ජල සැපයුම පහසු කරනවා පමණක් නොව ඔබේ වියදමත් අවම කරනවා.  වැසි සමයක භූමියේ ජල බැස්ම සිදුවන ආකාරය දැනගෙන බිම් සැකසීමත් අනවශ්‍ය කරදර අවම කරගැනීමට මඟක්. ඔබ තෝරාගන්නා භෝගවලට ජලය යෙදිය යුතු ප්‍රමාණ හා වේලාවන් පිළිබඳවත් කල්තියා දැන ගැනීමෙන් ඔබේ කාලයත්, ශ්‍රමයත් දෙකම සැලකිය යුතු අයුරින් අඩු කරගැනීමට ඉවහල් වෙනවා. ",
      image: images.bgblog5,
      image2: images.PopularBlog6,
      id: "blog6",
      shorturl: "#blog6",
    },
    {
      topic: "වැසි සමයේ බෝග රැකගන්නේ කොහොමද?",
      date: "September 11,2022",
      desc: "වැස්ස කියන්නෙ වගාවකට නැතිවම බැරි දෙයක් වුනත් ප්‍රමාණයට වඩා වැසි ලැබීම භෝග හානියට බලපාන ප්‍රධාන සාධකයක්. මේ නිසා වැසි සමයක භෝග ආරක්ෂා කර ගැනීම ගොවියෙකු විසින් ප්‍රගුණ කළ යුතු ශිල්පයක්. මේ සඳහා විවිධ ක්‍රම ගණනාවක්ම තිබෙනවා.තද වැසි ඍජුව නොවැටෙන භූමියක් ක්ෂේත්‍රය ලෙස සකසා ගැනීම මුලින්ම කළ යුතු දෙයක්. ඊට අමතරව ක්ෂේත්‍රෙය් ජලය බැස යාමට හොඳ කාණු පද්ධතියක් සැකසීමත් අනිවාර් යෙන්ම කළ යුතුයි. බැවුම් ඉඩමක ජලය ගලා යාම වේගවත් නිසා එය පාලනයට වැටි යෙදීම, අගල් සැකසීම වැනි ක්‍රම ද භාවිත කළ හැකියි. පාත්ති පොළව මට්ටමෙන් ඉහළට එසවීම ද වැසි සමයක භෝග රැක ගැනීම සඳහා අනුගමනය කළ හැකි පියවරක්.ඔබ කුඩා පරිමාණයෙන් භෝග වගා කරන ගොවියෙකු නම් භෝග වර්ග වෙන වෙනම පෝච්චිවල සිටුවීමෙන් පහසුවෙන්ම භෝග වැස්සෙන් ආරක්ෂා කරගැනීමට හැකියාව ලැබෙනවා. තරමක වියදම්කාරී හා වෙහෙසකර කටයුත්තක් වුවත් පොලිතින් වැනි ආවරණ යොදා භෝග ආරක්ෂා කරගැනීමට හැකි නම් එය ඔබට අනුගමනය කළ හැකි ඉතාමත් සාර්ථක ක්‍රමයක්.වැසි ජලය රැස් කළ හැකි ක්‍රමවේද පිළිබඳ දැනුමක් ඇත්නම් වැසි ජලය හොඳින් ලැබෙන වකවානුවක ඔබට පහසුවෙන් වැසි ජලය රැස්කර පසු කලෙක භාවිතයට ගැනීමට හැකි වෙනවා. වැසි සමය කරදරකාරී එකක් වුනත් එයින් උපරිම ඵල නෙලා ගන්නා සාර්ථක ගොවියෙකු බවට පත් වීමටත් මේ නිසා ඔබට අවස්ථාව උදාවනු ඇති.",
      image: images.bgblog6,
      image2: images.PopularBlog7,
      id: "blog7",
      shorturl: "#blog7",
    },
    {
      list: [
        "Boil water.",
        "Pour half of the hot water over the tea leaves. Let it brew for 10 minutes.",
        "Strain the tea leaves out.",
        "Add sugar and mix until completely dissolved. (Skip this step if you prefer your iced tea to be unsweetened.)",
        "Add the remaining water and mix.",
        "Refrigerate for at least an hour.",
        "Garnish with lemon slices and/or mint leaves when serving.",
      ],
      topic: "Iced Tea recipe",
      date: "September 11,2022",
      desc: "Delightful and cool, our iced tea makes for a refreshing beverage on a hot day. It is easy to make and can be enjoyed sweet or unsweetened.",
      image: images.bgblog8,
      image2: images.PopularBlog8,
      id: "blog8",
      shorturl: "#blog8",
    },
    {
      list: [
        "Cut ginger into thin slices.",
        "Pour one cup of water (per serving) into a saucepan.",
        "Add the ginger and boil over high heat.",
        "Simmer for 5-10 minutes depending on how strong you want the tea to be.",
        "Strain the tea.",
        "Add a spoon of honey if you want some sweetness.",
      ],
      topic: "Ginger Tea recipe",
      date: "September 11,2022",
      desc: "Made with fresh ginger, ginger tea is both spicy and soothing. A beverage known for its calming effect, it also makes a great night cap",
      image: images.bgblog9,
      image2: images.PopularBlog9,
      id: "blog9",
      shorturl: "#blog9",
      dark: true,
    },
    {
      list: [
        "Creamy and flavourful, masala tea makes a delicious pick-me-up.",
        "Crush ginger, cinnamon, clove, cardamom and black pepper in a mortar with a pestle.",
        "Grate fresh ginger.",
        "Add the crushed spices and grated ginger to a saucepan with water. Simmer for 15 minutes.",
        "Add black tea and milk and heat slightly.",
        "Add sugar or sweetener and mix.",
        "Strain and serve.",
      ],
      topic: "Masala Tea recipe",
      date: "September 11,2022",
      desc: "Masala Tea recipe",
      image: images.bgblog10,
      image2: images.PopularBlog10,
      id: "blog10",
      shorturl: "#blog10",
      dark: true,
    },
  ]

  const [readMore, setReadMore] = useState()
  const [toggle, setToggle] = useState(true)
  const [activeIndex, setActiveIndex] = useState()
  const [filteredData, setFilteredData] = useState([])

  console.log(toggle)

  const handleFilter = event => {
    const searchWord = event.target.value
    const newFilter = blog.filter(value => {
      return value.topic.toLowerCase().includes(searchWord.toLowerCase())
    })
    setFilteredData(newFilter)

    if (searchWord === "") {
      setFilteredData([])
    } else {
      setFilteredData(newFilter)
    }
  }
  return (
    <Layout>
      <Seo title="Blog | Watawala" />
      <section className="mx-10">
        <div className="container mx-auto pt-40 pb-20 lg:px-0">
          <h1 hidden>
            "Indulge in Tea Nirvana: Immerse Yourself in Exquisite Delights at
            Our Enchanting Tea Shops"
          </h1>
          <div className="flex xl:flex-row flex-col gap-7 ">
            <div>
              {blog.map((item, index) => {
                return (
                  <div className="" key={index} id={item.id}>
                    <BackgroundImage
                      className="md:py-44 py-36 w-full rounded-3xl overflow-hidden relative "
                      {...item.image}
                      alt="Watawala"
                    >
                      <div className="px-10 absolute bottom-10 md:block hidden ">
                        <div
                          className={
                            item.dark
                              ? "text-2xl text-gray-800 font-semibold"
                              : "text-2xl text-white font-semibold"
                          }
                        >
                          {item.topic}
                        </div>
                        <div className="flex gap-3 text-white items-center pt-2">
                          <div>
                            <ClockIcon
                              className={
                                item.dark ? "w-6 text-gray-800" : "w-6 "
                              }
                            />
                          </div>
                          <div className={item.dark ? "text-gray-800" : ""}>
                            {item.date}
                          </div>
                        </div>
                      </div>
                    </BackgroundImage>
                    <div className="px-10 pt-8   md:hidden block ">
                      <div className="text-xl md:text-white text-black font-semibold w-full">
                        {item.topic}
                      </div>
                      <div className="flex gap-3 md:text-white text-black  items-center pt-2">
                        <div>
                          <ClockIcon className="w-6 " />
                        </div>
                        <div>{item.date}</div>
                      </div>
                    </div>
                    {item.list ? (
                      <div className="pt-8 xl:w-[800px] 2xl:w-[1000px] ">
                        <div className="">{item.desc}</div>
                        <div>
                          {readMore == index && toggle ? (
                            <ul className="pl-10 mt-5">
                              {item.list.map((item, index) => {
                                return (
                                  <li className="list-disc" key={index}>
                                    {item}
                                  </li>
                                )
                              })}
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="pt-8 xl:w-[800px] 2xl:w-[1000px] ">
                        {readMore == index && toggle
                          ? item.desc
                          : item.desc.substring(0, 600)}
                      </div>
                    )}
                    <div className="pt-8 pb-8">
                      <button
                        className="tracking-wide uppercase border text-black  font-light rounded-full px-6 py-2 hover:border-black duration-200 flex gap-3 items-center cursor-pointer "
                        onClick={() => {
                          setReadMore(index)
                          setToggle(!toggle)
                          setActiveIndex(index)
                        }}
                      >
                        {readMore == index && toggle
                          ? "READ LESS"
                          : "READ MORE"}
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="w-full">
              <div className="relative">
                <input
                  type="text"
                  className="flex justify-between bg-gray-100 py-4 px-4 mb-5 rounded-2xl items-center cursor-pointer  w-full focus:outline-none"
                  placeholder="Search posts"
                  onChange={handleFilter}
                />
                <div>
                  {filteredData.length != 0 && (
                    <div className="w-full  bg-gray-100 shadow-md absolute z-20 overflow-y-auto scrollbar-hide">
                      {filteredData.map((item, index) => {
                        return (
                          <div key={index} className="z-30 ">
                            <a href={item.shorturl}>
                              <div className="px-8 py-4 cursor-pointer hover:bg-slate-400 duration-200">
                                {item.topic}
                              </div>
                            </a>
                          </div>
                        )
                      })}
                    </div>
                  )}

                  <MagnifyingGlassIcon className="w-8 absolute right-0 top-0 m-3" />
                </div>
              </div>
              <div className="bg-gray-100 px-6 py-8 rounded-2xl w-full  items-center">
                <div className="text-xl font font-semibold ">POPULAR POSTS</div>
                {blog.map((item, index) => {
                  return (
                    <div key={index}>
                      <div>
                        <a href={item.shorturl}>
                          <div className="flex md:flex-row flex-col gap-4 items-center pt-8">
                            <div>
                              <GatsbyImage
                                image={item.image2}
                                alt="Watawala"
                                className="md:w-20 w-full md:h-20 h-44 rounded-md"
                              />
                            </div>
                            <div>
                              <div className="font-semibold">{item.topic}</div>
                              <div className="text-gray-800">{item.date}</div>
                            </div>
                          </div>
                        </a>
                        <div className="bg-gray-500/20 h-[1px] w-full mt-8"></div>
                      </div>
                    </div>
                  )
                })}
              </div>

              <div className="bg-gray-100 px-4 py-8 rounded-2xl mt-8">
                <div className="text-xl font font-semibold ">FOLLOW US</div>
                <div>
                  <div className="flex gap-5 mt-8">
                    <a
                      href="https://www.facebook.com/WatawalaTeaSriLanka/"
                      target="_blank"
                      className="group"
                    >
                      <div className="group-hover:hidden block">
                        <StaticImage
                          src="../images/icons/social-black/facebook.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                      <div className="group-hover:block hidden">
                        <StaticImage
                          src="../images/icons/social/facebookYellow.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                    </a>
                    <a
                      href="https://www.instagram.com/watawalatea/"
                      target="_blank"
                      className="group"
                    >
                      <div className="group-hover:hidden block">
                        <StaticImage
                          src="../images/icons/social-black/insta.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                      <div className="group-hover:block hidden">
                        <StaticImage
                          src="../images/icons/social/instagramYellow.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCYWRbGloP_sXJ_BsiDqY00w"
                      target="_blank"
                      className="group"
                    >
                      <div className="group-hover:hidden block">
                        <StaticImage
                          src="../images/icons/social-black/youtube.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                      <div className="group-hover:block hidden">
                        <StaticImage
                          src="../images/icons/social/youtubeYellow.png"
                          className="w-10"
                          alt="Watawala"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Blog

export const query = graphql`
  query BlogpageImages {
    gardening: file(relativePath: { eq: "blog/gardening.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    grow: file(relativePath: { eq: "blog/grow.jpeg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    vegetable: file(relativePath: { eq: "blog/vegetable.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog1: file(relativePath: { eq: "blog/Blognew01.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog2: file(relativePath: { eq: "blog/Blognew02.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog3: file(relativePath: { eq: "blog/Blognew03.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog4: file(relativePath: { eq: "blog/Blognew04.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog5: file(relativePath: { eq: "blog/Blognew05.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog6: file(relativePath: { eq: "blog/Blognew06.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }

    blog7: file(relativePath: { eq: "blog/Blognew07.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }

    blog8: file(relativePath: { eq: "blog/new-recipe-iced-tea-blog.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog9: file(relativePath: { eq: "blog/new-recipe-ginger-tea-blog.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    blog10: file(relativePath: { eq: "blog/new-recipe-masala-tea-blog.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }

    PopularBlog1: file(relativePath: { eq: "blog/PopularBlog1.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog2: file(relativePath: { eq: "blog/PopularBlog2.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog3: file(relativePath: { eq: "blog/PopularBlog3.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog4: file(relativePath: { eq: "blog/PopularBlog4.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog5: file(relativePath: { eq: "blog/PopularBlog5.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog6: file(relativePath: { eq: "blog/PopularBlog6.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog7: file(relativePath: { eq: "blog/PopularBlog7.png" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog8: file(relativePath: { eq: "blog/PopularBlog8.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog9: file(relativePath: { eq: "blog/PopularBlog9.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
    PopularBlog10: file(relativePath: { eq: "blog/PopularBlog10.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 100, placeholder: BLURRED)
      }
    }
  }
`
